module.exports = __webpack_public_path__ + "img/module-appointments.d153ac8f.svg";